import React from 'react';
import { Box, Stack, Typography } from '@mui/material';

/// Cabeçalho padrão das telas: título forte, linha de apoio e ações à direita.
export default function PageHeader({ title, subtitle, actions, sx }) {
  return (
    <Stack
      direction={{ xs: 'column', md: 'row' }}
      justifyContent="space-between"
      alignItems={{ md: 'center' }}
      spacing={2}
      sx={{ mb: 3, ...sx }}
    >
      <Box sx={{ minWidth: 0 }}>
        <Typography variant="h4" fontWeight={900}>
          {title}
        </Typography>
        {subtitle && <Typography color="text.secondary">{subtitle}</Typography>}
      </Box>
      {actions && (
        <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
          {actions}
        </Stack>
      )}
    </Stack>
  );
}
